"use client"
import styled from "@emotion/styled"
import { NewActiveArms } from "ui"

type Props = {
  data: any
  locale: string
}

const Section = styled.section`
  padding: 40px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 80px 0;
  }
`

function MasterProjectActiveArms({ data, locale }: Props) {
  return (
    <Section>
      <NewActiveArms data={data} locale={locale} page="master-project" />
    </Section>
  )
}

export default MasterProjectActiveArms
